import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-col flex-wrap md:flex-row mr-auto lg:justify-start justify-center mx-auto" }
const _hoisted_3 = { class: "max-w-lg w-full md:w-56 lg:max-w-xs" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_5 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_6 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "px-5" }
const _hoisted_9 = { class: "py-6" }
const _hoisted_10 = ["data"]
const _hoisted_11 = { class: "w-full md:w-1/6 min-h-full" }
const _hoisted_12 = { class: "shadow p-3 bg-blue-100 rounded-md h-28 xl:h-auto" }
const _hoisted_13 = { class: "font-bold text-lg" }
const _hoisted_14 = { class: "text-sm" }
const _hoisted_15 = { class: "w-full md:w-1/6 min-h-full" }
const _hoisted_16 = { class: "shadow p-3 bg-indigo-100 rounded-md h-28 xl:h-auto" }
const _hoisted_17 = { class: "font-bold text-lg" }
const _hoisted_18 = { class: "text-sm" }
const _hoisted_19 = { class: "w-full md:w-1/6 min-h-full" }
const _hoisted_20 = { class: "shadow p-3 bg-yellow-100 rounded-md h-28 xl:h-auto" }
const _hoisted_21 = { class: "font-bold text-lg" }
const _hoisted_22 = { class: "text-sm" }
const _hoisted_23 = { class: "w-full md:w-1/6 min-h-full" }
const _hoisted_24 = { class: "shadow p-3 bg-green-100 rounded-md h-28 xl:h-auto" }
const _hoisted_25 = { class: "font-bold text-lg" }
const _hoisted_26 = { class: "text-sm" }
const _hoisted_27 = { class: "w-full md:w-1/6 min-h-full" }
const _hoisted_28 = { class: "shadow p-3 bg-red-100 rounded-md h-28 xl:h-auto" }
const _hoisted_29 = { class: "font-bold text-lg" }
const _hoisted_30 = { class: "text-sm" }
const _hoisted_31 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_32 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { inject, onMounted, ref, watch } from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import DateSelector from "@/components/tools/DateSelector.vue";
import NonAffiliateDetailTableDialog from "@/components/dialogs/NonAffiliateDetailTableDialog.vue";
import DropdownComponent from "@/components/tools/DropdownComponent.vue";
import { formatNumber, translate } from "@/utils/tools";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/vue";
import { fal } from "@fortawesome/pro-light-svg-icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'NonAffiliateSummaryV2',
  setup(__props) {

dayjs.extend(localizedFormat);
const SelectorIcon = require("@heroicons/vue/solid/SelectorIcon");
const CheckIcon = require("@heroicons/vue/solid/CheckIcon");
const SearchIcon = require("@heroicons/vue/solid/SearchIcon");
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const advanceFilterModal = ref(false);
const selectedOption = ref({
  label: "Yesterday",
  value: dayjs().add(-1, "day").format(),
});
const months: any = ref([]);
const startDate = dayjs();
const beginningDate = "2022-01-01";
const diff = startDate.diff(beginningDate, "months");
const dateSelectorRef = ref(null);
let grandTotalData = ref({
  total_user: 0,
  win_loss: 0,
  total_topup_amount: 0,
  total_bet_amount: 0,
  total_withdraw_amount: 0,
});

for (let i = 0; i <= diff; i++) {
  months.value.push({
    label: dayjs(beginningDate).add(i, "month").format("MM/YYYY"),
    value: dayjs(beginningDate).add(i, "month").format(),
  });
}
months.value.push({
  label: "Yesterday",
  value: dayjs().add(-1, "day").format(),
});

const onMonthChange = (data: any) => {
  selectedOption.value = data;
  filterByMonth(data);
};

const columns = ref([
  {
    label: translate("messages.nonAffiliateSummary.accountName"),
    field: "account_name",
    format: (data: any) => (data.account_name ? data.account_name : "-"),
  },
  {
    label: translate("messages.nonAffiliateSummary.username"),
    field: "username",
    align: "center",
    format: (data: any) => (data.username ? data.username : "-"),
  },
  {
    label: translate("messages.nonAffiliateSummary.betTotal"),
    field: "bet_total",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.bet_total),
    class: (data: any) =>
      Number(data.bet_total) < 0
        ? "text-red-500"
        : "text-green-500",
  },
  {
    label: translate("messages.nonAffiliateSummary.settleTotal"),
    field: "settle_total",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.settle_total),
    class: (data: any) =>
      Number(data.settle_total) < 0
        ? "text-red-500"
        : "text-green-500",
  },
  {
    label: translate("messages.nonAffiliateSummary.topupTotal"),
    field: "topup_total",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.topup_total),
    class: (data: any) =>
      Number(data.topup_total) < 0
        ? "text-red-500"
        : "text-green-500",
  },
  {
    label: translate("messages.nonAffiliateSummary.withdrawTotal"),
    field: "withdraw_total",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.withdraw_total),
    class: (data: any) =>
      Number(data.withdraw_total) < 0
        ? "text-red-500"
        : "text-green-500",
  },
  {
    label: translate("messages.nonAffiliateSummary.rtbDepositTotal"),
    field: "rtb_deposit_total",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.rtb_deposit_total),
    class: (data: any) =>
      Number(data.rtb_deposit_total) < 0
        ? "text-red-500"
        : "text-green-500",
  },
  {
    label: translate("messages.nonAffiliateSummary.rtbWithdrawTotal"),
    field: "rtb_withdraw_total",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.rtb_withdraw_total),
    class: (data: any) =>
      Number(data.rtb_withdraw_total) < 0
        ? "text-red-500"
        : "text-green-500",
  },
  {
    label: translate("messages.nonAffiliateSummary.winloss"),
    field: "win_loss",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.win_loss),
    class: (data: any) =>
      Number(data.win_loss) < 0
        ? "text-red-500"
        : "text-green-500",
  },
]);
const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  search: undefined,
  sort: ["win_loss", "DESC"],
});
const filterForm = ref({
  username: null,
  channel: null,
  moduleCode: null,
  from: null,
  to: null,
});
const dataRow = ref();
const showDialog = (data: any) => {
  dataRow.value = data;
  advanceFilterModal.value = true;
};

const filterModal = (data = { flag: 0, chanel: null }) => {
  advanceFilterModal.value = !advanceFilterModal.value;
  if (data.flag == 1) {
    pageConfig.value.page = 1;
    filterForm.value.channel = data.chanel;
    fetchPageData();
  }
};
const doSort = (attName: string) => {
  const index = columns.value.findIndex((column) => column.label === attName);

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[1];
  if (attName === "Win/Loss") attName = "win_loss";

  pageConfig.value.sort = [
    attName.toLowerCase().replace(/ /g, "_"),
    mode === "DESC" ? "ASC" : "DESC",
  ];

  fetchPageData();
};
const fetchPageData = async (reset = false) => {
  isLoaded.value = false;
  const { page, rowsPerPage, sort, search } = pageConfig.value;
  const { from, to } = filterForm.value;
  // let sort = [['win_loss', 'DESC']]
  // let sort = sortBy.value.length ? sortBy.value : [['win_loss', 'DESC']];
  let offset = page * rowsPerPage - rowsPerPage;
  if (reset) {
    offset = 0;
    pageConfig.value.page = 1;
  }

  const payload: any = {
    operator_id: store.state.selectedOperator.operatorId,
    offset: offset,
    limit: rowsPerPage,
    search,
    start_date: from
      ? dayjs(from).format("YYYY-MM-DD")
      : dayjs().add(-1, "day").format("YYYY-MM-DD"),
    end_date: to
      ? dayjs(to).format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD"),
    sort_by: sort,
    // phone_number: phone,
    // search: searchInput.value,
  };
  // if (!phone_number) delete payload.phone_number;
  // if (!search) delete payload.search;
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/cms/summaries/menu/non-affiliate`;
  const rows = await axios
    .post(url, payload)
    .then(({ data }) => data);

  // if(!rows || rows.length == 0){
  //   if(pageConfig.value.page == 1){
  //     dataRows.value = []
  //     isLoaded.value = true;
  //     return
  //   }
  //   pageConfig.value.page = page - 1
  //   return
  // }
  pageConfig.value.dataLength = rows.length;
  let count = pageConfig.value.dataLength

  dataRows.value = rows;

  pageConfig.value = {
    ...pageConfig.value,
    count,
    pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `non-affiliate-summary?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};

const refetchTotalData = async () => {
  isLoaded.value = false;
  let { from, to } = filterForm.value as any;
  from = from
    ? dayjs(from).format("YYYY-MM-DD")
    : dayjs().add(-1, "day").format("YYYY-MM-DD");
  to = to ? dayjs(to).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
  axios
    .post(
      process.env.VUE_APP_API_ENDPOINT +
        "/admin/api/v1/cms/summaries/menu/non-affiliate-report",
      {
        operator_id: store.state.selectedOperator.operatorId,
        start_date: from,
        end_date: to,
      }
    )
    .then(({ data }) => {
      grandTotalData.value.total_user = data.total_user || 0;
      grandTotalData.value.win_loss = data.win_loss || 0;
      grandTotalData.value.total_bet_amount = data.total_bet_amount || 0;
      grandTotalData.value.total_topup_amount = data.total_topup_amount || 0;
      grandTotalData.value.total_withdraw_amount =
        data.total_withdraw_amount || 0;
      isLoaded.value = true;

      // console.log({ rows: dataRows.value })
    })
    .catch(({ response }) => {
      console.log(response.data);
    });
};

const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.from = payload.from;
  filterForm.value.to = payload.to;
  isLoaded.value = false;
  pageConfig.value.page = 1;
  fetchPageData();
  refetchTotalData();
};

const filterByMonth = (payload: any) => {
  let from: any = dayjs(payload.value).startOf("month").format("YYYY-MM-DD");
  let to: any = dayjs(payload.value).endOf("month").format("YYYY-MM-DD");
  if (payload.label == "Yesterday") {
    from = dayjs(payload.value)
      .hour(0)
      .minute(0)
      .second(0)
      .format("YYYY-MM-DD");
    to = dayjs(payload.value)
      .hour(23)
      .minute(59)
      .second(59)
      .format("YYYY-MM-DD");
  }

  // console.log('dateSelectorRef', dateSelectorRef);
  (dateSelectorRef.value as any).state = {
    from: dayjs(from).format("YYYY-MM-DD"),
    to: dayjs(to).format("YYYY-MM-DD"),
  };

  isLoaded.value = false;
  filterForm.value.from = from;
  filterForm.value.to = to;
  fetchPageData();
  refetchTotalData();
};

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
  refetchTotalData();
});
/** fetch data when current page was changed */
watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.nonAffiliateSummary.nonAffiliateSummary')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(SearchIcon), {
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (fetchPageData(true))),
              maxlength: "10",
              class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
              placeholder: _ctx.$t('messages.nonAffiliateSummary.search'),
              type: "search",
              name: "search"
            }, null, 40, _hoisted_7), [
              [_vModelText, pageConfig.value.search]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(DropdownComponent, {
            modelValue: selectedOption.value,
            options: months.value,
            onOnOptionSelected: onMonthChange
          }, null, 8, ["modelValue", "options"])
        ]),
        _createVNode(DateSelector, {
          class: "w-full flex flex-row justify-between",
          onSearch: onSearch,
          ref_key: "dateSelectorRef",
          ref: dateSelectorRef
        }, null, 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", {
        class: "px-9 pb-4 md:flex md:flex-row md:flex-wrap md:flex-1 md:justify-evenly grid grid-cols-2 gap-2 gap-y-4 place-items-center",
        data: _unref(grandTotalData)
      }, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(parseFloat(_unref(grandTotalData).total_user + "").toLocaleString(
                  "en",
                  { useGrouping: true }
                )), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("messages.nonAffiliateSummary.totalUsers")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString((parseFloat(_unref(grandTotalData).win_loss + "") / 100).toLocaleString(
                  "en",
                  {
                    useGrouping: true,
                    minimumFractionDigits: 2,
                  }
                )), 1),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("messages.nonAffiliateSummary.totalWinLoss")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, _toDisplayString((
                  parseFloat(_unref(grandTotalData).total_bet_amount + "") / 100
                ).toLocaleString("en", {
                  useGrouping: true,
                  minimumFractionDigits: 2,
                })), 1),
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("messages.nonAffiliateSummary.totalBetAmount")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, _toDisplayString((
                  parseFloat(_unref(grandTotalData).total_topup_amount + "") / 100
                ).toLocaleString("en", {
                  useGrouping: true,
                  minimumFractionDigits: 2,
                })), 1),
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("messages.nonAffiliateSummary.totalTopupAmount")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, _toDisplayString((
                  parseFloat(_unref(grandTotalData).total_withdraw_amount + "") / 100
                ).toLocaleString("en", {
                  useGrouping: true,
                  minimumFractionDigits: 2,
                })), 1),
            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("messages.nonAffiliateSummary.totalWithdrawAmount")), 1)
          ])
        ])
      ], 8, _hoisted_10),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(DataTable, {
            columns: columns.value,
            data: dataRows.value,
            onSort: doSort,
            onShowDetailTable: showDialog,
            isLoaded: isLoaded.value
          }, null, 8, ["columns", "data", "isLoaded"]),
          _createVNode(Pagination, {
            config: pageConfig.value,
            "onUpdate:config": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig).value = $event))
          }, null, 8, ["config"])
        ])
      ])
    ]),
    _createVNode(NonAffiliateDetailTableDialog, {
      class: "z-10 w-full",
      show: advanceFilterModal.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((advanceFilterModal).value = $event)),
      dataRows: dataRow.value
    }, null, 8, ["show", "dataRows"])
  ]))
}
}

})